import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import EditPackageModal from '../Modals/EditPackageModal';

import styles from './ChangePackage.module.scss';

import changePkgIcon from '../../public/images/change-package-icon.svg';

const { 'make-change-cta': makeChangeCTAClass } = styles;

const ChangePackageCTA = ({
  titleCopy = 'Want to make an update?',
  btnCopy = 'Change plan or package'
}) => {
  const { authUser, preneedPackages = [] } = useSelector(({ authUser, webPurchase }) => ({
    authUser: authUser,
    preneedPackages: webPurchase.preneedPackages.data?.packages
  }));

  const { data: userData, planPackageUpdated } = authUser || {};

  //component state
  const [isChangePackageModalOpen, setChangePackageModalOpen] = useState(false);

  //close modal on success
  useEffect(() => {
    if (planPackageUpdated) {
      setChangePackageModalOpen(false);
      window?.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [planPackageUpdated, userData]);

  return (
    <div className={makeChangeCTAClass}>
      <h5>{titleCopy}</h5>
      <button onClick={() => setChangePackageModalOpen(true)}>
        <img src={changePkgIcon} alt="edit" />
        {btnCopy}
      </button>
      <EditPackageModal
        {...{ userData }}
        packageInfo={preneedPackages}
        modalVisible={isChangePackageModalOpen}
        closeModal={() => setChangePackageModalOpen(false)}
      />
    </div>
  );
};

export default ChangePackageCTA;
